import { naturalSort } from "@dhx/ts-common/core";
import { DateFormatter } from "./DateFormatter";
import locale from "./locales/en";
import { IField } from "./types";

export const dateFormatter = new DateFormatter();

function fastWrap(format: DateFormatter, idMask: string, labelMask: string) {
	const id = format.date_to_str(idMask);
	const label = format.date_to_str(labelMask);

	return function(val) {
		return {
			id: id(val),
			label: label(val),
		};
	};
}

export const groupMethods = {
	dateByDay: fastWrap(dateFormatter, "%P", "%D"),
	dateByMonth: fastWrap(dateFormatter, "%m", "%M"),
	dateByQuarter: fastWrap(dateFormatter, "%q", "%Q"),
	dateByWeek: fastWrap(dateFormatter, "%W", `${locale.date.week}%W`),
	dateByYear: fastWrap(dateFormatter, "%Y", "%Y"),
};

export function strToDate(val: any, format = "%d/%m/%Y") {
	return dateFormatter.str_to_date(format)(val);
}

export function dateToStr(val: any, format: string) {
	return dateFormatter.date_to_str(format)(val);
}

export function getUniqueFieldData(field: IField, data: any[]): any[] {
	if (field.type === "date") {
		return naturalSort(
			data.map(item => item[field.id].getTime()).filter((el, i, arr) => arr.indexOf(el) === i)
		);
	}
	return naturalSort(data.map(item => item[field.id]).filter((el, i, arr) => arr.indexOf(el) === i));
}
